import { ForwardedRef, forwardRef } from 'react';
import { Pattern, SwatchBorderStyle } from '@common/api';
import { ColorBadge } from './ColorBadge';
import { ColorBadgeOuter, ColorBadgeInner, ColorBadgeBar } from './Color.style';

export type ColorBadgeSplitProps = {
    first?: string | null;
    second?: string | null;
    firstBorder?: string | null;
    secondBorder?: string | null;
    borderStyle?: SwatchBorderStyle;
    pattern?: Pattern;
    disabled?: boolean;
    round?: boolean;
};

export const ColorBadgeSplit = forwardRef((props: ColorBadgeSplitProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { first, second, firstBorder, secondBorder, borderStyle, pattern, disabled, round } = props;

    if (first === second) {
        return (
            <ColorBadge
                disabled={disabled}
                color={first}
                border={firstBorder}
                borderStyle={borderStyle}
                pattern={pattern}
                round={round}
                ref={ref}
            />
        );
    }

    return (
        <ColorBadgeOuter $disabled={disabled} $round={round} ref={ref}>
            <ColorBadgeInner
                className="color-badge-half"
                $color={first}
                $border={firstBorder}
                $borderStyle={borderStyle}
                $pattern={pattern}
                $round={round}
            />
            <ColorBadgeInner
                className="color-badge-half"
                $color={second}
                $border={secondBorder}
                $borderStyle={borderStyle}
                $pattern={pattern}
                $round={round}
            />
            <ColorBadgeBar />
        </ColorBadgeOuter>
    );
});

ColorBadgeSplit.displayName = 'ColorBadgeSplit';
